import { useMutation } from "@tanstack/react-query";
import { postPushOrderToEvitals } from "apis";

export default function usePostPushOrderToEvitals() {
  return useMutation(postPushOrderToEvitals);
}
